import { render, staticRenderFns } from "./OpeningSessionSuspensionForCorrectionModal.vue?vue&type=template&id=56756f2e&scoped=true&"
import script from "./OpeningSessionSuspensionForCorrectionModal.vue?vue&type=script&lang=js&"
export * from "./OpeningSessionSuspensionForCorrectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56756f2e",
  null
  
)

export default component.exports